import MobileLayout from './FileUploaderInputLayout.mobile';
import WebLayout from './FileUploaderInputLayoutWeb';
import { isReactNative } from 'ui-builder';

export default isReactNative() ? MobileLayout : WebLayout;
